import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {ProjectReferenceAttributeService} from '../project-reference-attribute.service';
import {ProjectReferenceAttributeResponse} from '../../models/project-reference-attribute-response';
import {ProjectReferenceAttributesUpdateRequest} from '../../models/project-reference-attribute-update-request';

const mockAttributes: ProjectReferenceAttributeResponse = {
    readonlyAttributes: {
        type: 'Test project',
        buildingClassification: ['Gebouw'],
        buildingSubClassification: ['gebouw-woning', 'gebouw-bouw'],
        vwConcept: 'WoningBouw',
        sustainabilityClass: null
    },
    coreDataProject: null,
    surfaceVVO: null,
    surfaceFacade: null,
    locationSize: null,
    buildingLayersAboveGround: null,
    buildingLayersUnderGround: null,
    demolitionSize: null,
    remediateSize: null,
    readyForConstructionSize: null,
    readyToLiveSize: null,
    keyFeatures: null,
    maintanceContractYears: null,

    urbanDensity: {
        code: 'OMSDH00',
        title: 'Stedelijkheid (van een gebied)',
        multiple: false,
        values: [
            {
                id: 'OMSDH00_001',
                title: 'Zeer sterk stedelijk',
                parentIds: [],
                order: null
            },
            {
                id: 'OMSDH00_002',
                title: 'Sterk stedelijk',
                parentIds: [],
                order: null
            },
            {
                id: 'OMSDH00_003',
                title: 'Matig stedelijk',
                parentIds: [],
                order: null
            },
            {
                id: 'OMSDH00_004',
                title: 'Weinig stedelijk',
                parentIds: [],
                order: null
            },
            {
                id: 'OMSDH00_005',
                title: 'Niet stedelijk',
                parentIds: [],
                order: null
            }
        ],
        selectedValueId: 'OMSDH00_002'
    },
    energyLabel: {
        code: 'DUELA00',
        title: 'Energielabel',
        multiple: false,
        values: [
            {
                id: 'DUELA00_001',
                title: 'A++++',
                parentIds: [],
                order: null
            },
            {
                id: 'DUELA00_002',
                title: 'A+++',
                parentIds: [],
                order: null
            },
            {
                id: 'DUELA00_003',
                title: 'A++',
                parentIds: [],
                order: null
            },
            {
                id: 'DUELA00_004',
                title: 'A+',
                parentIds: [],
                order: null
            },
            {
                id: 'DUELA00_005',
                title: 'A',
                parentIds: [],
                order: null
            },
            {
                id: 'DUELA00_006',
                title: 'B',
                parentIds: [],
                order: null
            },
            {
                id: 'DUELA00_007',
                title: 'C',
                parentIds: [],
                order: null
            },
            {
                id: 'DUELA00_008',
                title: 'D',
                parentIds: [],
                order: null
            },
            {
                id: 'DUELA00_009',
                title: 'F',
                parentIds: [],
                order: null
            },
            {
                id: 'DUELA00_010',
                title: 'G',
                parentIds: [],
                order: null
            }
        ],
        selectedValueId: null
    },
    riskManagement: {
        code: 'KRQSC00',
        title: 'Initiële Quickscan-classificatie',
        multiple: false,
        values: [
            {
                id: 'KRQSC00_001',
                title: 'Groen (laag)',
                parentIds: [],
                order: null
            },
            {
                id: 'KRQSC00_002',
                title: 'Oranje (middel)',
                parentIds: [],
                order: null
            },
            {
                id: 'KRQSC00_003',
                title: 'Rood (hoog)',
                parentIds: [],
                order: null
            }
        ],
        selectedValueId: null
    },

    // ProjectScope attributes
    projectScopeFromMDM: false,
    unitsForSale: 10,
    unitsForRent: 40,
    surfaceBVO: 2000,
    surfaceLot: 400,
    totalBuildingObjects: 10,
    grossVolume: 1000,
}

@Injectable({
    providedIn: 'root'
})
export class ProjectReferenceAttributeServiceMock implements ProjectReferenceAttributeService {
    listAttributes(refId: number): Observable<ProjectReferenceAttributeResponse> {
        return of(mockAttributes);
    }

    saveAttributes(refId: number, attributes: ProjectReferenceAttributesUpdateRequest): Observable<ProjectReferenceAttributeResponse> {
        return of(mockAttributes);
    }
}
